export default {"src":"/_next/static/image/public/images/ic_shield_blue_vertical_menu.5b86acab30e78231923b56a6fef314db.svg","height":20,"width":20};